// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderCartButton_wrapper__LHllD","textDiv":"HeaderCartButton_textDiv__B5cKA","floatingContentWrapper":"HeaderCartButton_floatingContentWrapper__KR-LV"};